import "./Solutions.css";

/* ── Иконки ────────────────────────────────────────────────── */
const IconNetwork = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="16" y="16" width="6" height="6" rx="1"/><rect x="2" y="16" width="6" height="6" rx="1"/><rect x="9" y="2" width="6" height="6" rx="1"/>
    <path d="M5 16v-4h14v4"/><path d="M12 12V8"/>
  </svg>
);
const IconFactory = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 20h20"/><path d="M2 20V9l6-5v5l6-5v5l6-5v11"/>
  </svg>
);
const IconServer = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="8" rx="2"/><rect x="2" y="14" width="20" height="8" rx="2"/>
    <line x1="6" y1="6" x2="6.01" y2="6"/><line x1="6" y1="18" x2="6.01" y2="18"/>
  </svg>
);
const IconWifi = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12.55a11 11 0 0 1 14.08 0"/><path d="M1.42 9a16 16 0 0 1 21.16 0"/><path d="M8.53 16.11a6 6 0 0 1 6.95 0"/>
    <circle cx="12" cy="20" r="1" fill="currentColor"/>
  </svg>
);
const IconBrain = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96-.46 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.88A2.5 2.5 0 0 1 9.5 2Z"/>
    <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96-.46 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.88A2.5 2.5 0 0 0 14.5 2Z"/>
  </svg>
);
const IconCamera = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/>
    <circle cx="12" cy="13" r="3"/>
  </svg>
);
const IconShield = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);
const IconMonitor = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
  </svg>
);
const IconSettings = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>
  </svg>
);
const IconBox = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="21 8 21 21 3 21 3 8"/><rect x="1" y="3" width="22" height="5"/><line x1="10" y1="12" x2="14" y2="12"/>
  </svg>
);
const IconTool = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
  </svg>
);
const IconHeadphones = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/>
  </svg>
);

/* ── Данные карточек ────────────────────────────────────────── */
const SOLUTIONS = [
  {
    icon: IconNetwork,
    title: "Сети связи и СКС",
    description: "СКС, ВОЛС и корпоративные сети передачи данных для объектов в Екатеринбурге и УрФО",
    tag: "Ключевое",
    bullets: [
      "СКС категорий 6/6A, медные и оптические линии",
      "ВОЛС, кроссовые узлы, телекоммуникационные шкафы",
      "Wi-Fi, коммутаторы, маршрутизаторы, VPN",
      "Исполнительная документация и маркировка линий",
    ],
  },
  {
    icon: IconFactory,
    title: "Промышленные сети и безопасность",
    description: "Сети связи и IT-инфраструктура для промышленных и логистических объектов",
    tag: null,
    bullets: [
      "Структурированные кабельные системы",
      "Промышленные сети передачи данных",
      "СОТ, СКУД и периметральная безопасность",
      "Интеграция с АСУ ТП и SCADA",
    ],
  },
  {
    icon: IconServer,
    title: "Серверные и ЦОД",
    description: "Проектирование и оснащение серверных и центров обработки данных под ключ",
    tag: "Ключевое",
    bullets: [
      "Серверные стойки, шкафы, кросс-панели",
      "Системы бесперебойного питания и резервирование",
      "Прецизионное охлаждение и климат-контроль",
      "Мониторинг температуры, влажности, доступа",
      "СКС категорий 6/6A и ВОЛС",
    ],
  },
  {
    icon: IconWifi,
    title: "Корпоративные сети",
    description: "Сети передачи данных для офисов, производств и распределённых филиалов",
    tag: null,
    bullets: [
      "СКС, оптические магистрали, ВОЛС",
      "Wi-Fi 6/6E, бесшовный роуминг",
      "Корпоративные коммутаторы и маршрутизаторы",
      "VPN, сегментация, контроль доступа",
    ],
  },
  {
    icon: IconBrain,
    title: "Локальные ИИ-агенты и LLM",
    description: "On-prem LLM и ИИ-агенты для компаний, которым нужен локальный ИИ без передачи данных вовне",
    tag: "Дополнительно",
    bullets: [
      "Llama, Qwen, GigaChat и другие LLM",
      "ИИ-агенты для рутинных операций и отчётности",
      "Обработка ТЗ, актов, протоколов, заявок",
      "Интеграция с 1С, СЭД и внутренними сервисами",
      "GPU-серверы и инференс-узлы под нагрузку",
    ],
  },
  {
    icon: IconCamera,
    title: "IP-видеонаблюдение",
    description: "IP-камеры, видеоаналитика и архивация для офисов, ритейла, складов и бизнес-центров",
    tag: null,
    bullets: [
      "IP-камеры HD/4K, fish-eye, PTZ",
      "Видеорегистраторы и серверы хранения",
      "Видеоаналитика: лица, номера, события",
      "Удалённый доступ и мобильные приложения",
    ],
  },
  {
    icon: IconShield,
    title: "СКУД и контроль доступа",
    description: "Системы контроля и управления доступом для офисов и режимных объектов",
    tag: null,
    bullets: [
      "Контроллеры, турникеты, шлагбаумы",
      "Карты, биометрия, мобильный пропуск",
      "Учёт рабочего времени, интеграция с HR/1С",
      "Многоуровневые зоны доступа",
      "Интеграция с видеонаблюдением и охраной",
    ],
  },
  {
    icon: IconMonitor,
    title: "Конференц-системы и мультимедиа",
    description: "Оснащение переговорных, залов заседаний и презентационных пространств",
    tag: null,
    bullets: [
      "Видеостены, проекторы, интерактивные дисплеи",
      "Видеоконференцсвязь, синхроперевод",
      "Аудиосистемы, микрофонные пульты",
      "Управление одной кнопкой, сценарии, расписания",
    ],
  },
  {
    icon: IconSettings,
    title: "Автоматизация инженерных систем",
    description: "Диспетчеризация и управление инженерными системами зданий и производств",
    tag: null,
    bullets: [
      "Электро-, тепло-, водоснабжение",
      "Освещение, климат, вентиляция",
      "Сбор телеметрии, интеграция с MES/SCADA",
      "Сценарии и удалённое управление",
    ],
  },
  {
    icon: IconBox,
    title: "Поставка оборудования",
    description: "Подбор и поставка оборудования под ключ с прямыми контрактами",
    tag: null,
    bullets: [
      "Серверное и сетевое оборудование",
      "Электротехника, кабельная продукция, шкафы",
      "Камеры, контроллеры СКУД, видеоаналитика",
      "Расходные материалы и инструмент",
    ],
  },
  {
    icon: IconTool,
    title: "Пусконаладка и интеграция",
    description: "Запуск систем в эксплуатацию и сведение в единый технологический контур",
    tag: null,
    bullets: [
      "Настройка, тестирование, приёмочные испытания",
      "Программирование контроллеров и шлюзов",
      "Исполнительная документация, паспорта, инструкции",
      "Обучение персонала заказчика",
    ],
  },
  {
    icon: IconHeadphones,
    title: "Сервис и техподдержка",
    description: "Сервисные контракты и сопровождение инфраструктуры после сдачи объекта",
    tag: "24/7",
    bullets: [
      "Профилактика, мониторинг, аварийные выезды",
      "Удалённая диагностика и устранение неисправностей",
      "Обновление прошивок и конфигураций",
      "Отчётность и журнал обслуживания",
    ],
  },
];

/* ── Компонент ─────────────────────────────────────────────── */
export default function Solutions() {
  return (
    <section id="solutions" className="solutions">
      <div className="solutions__inner">

        {/* Заголовочная строка */}
        <div className="solutions__header">
          <div className="solutions__header-left">
            <p className="solutions__label">Наши возможности</p>
            <h2 className="solutions__title">
              Какие задачи<br />мы решаем
            </h2>
          </div>
          <div className="solutions__header-right">
            <p className="solutions__subtitle">
              Строительство сетей связи, СКС, СОТ, СКУД, серверные, телекоммуникационное оборудование, интеграция и сервис - для промышленных и коммерческих объектов Екатеринбурга и УрФО
            </p>
          </div>
        </div>

        {/* Сетка карточек */}
        <div className="solutions__grid">
          {SOLUTIONS.map((item, index) => {
            const Icon = item.icon;
            return (
              <div key={index} className="solutions__card">
                <div className="solutions__card-top">
                  <Icon />
                  <span className="solutions__card-num">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>

                <div className="solutions__card-tag-row">
                  {item.tag && (
                    <span className="solutions__card-tag">{item.tag}</span>
                  )}
                </div>

                <h3 className="solutions__card-title">{item.title}</h3>
                <p className="solutions__card-desc">{item.description}</p>

                <ul className="solutions__card-bullets">
                  {item.bullets.map((bullet, i) => (
                    <li key={i} className="solutions__card-bullet">
                      <span className="solutions__card-dot" />
                      <span>{bullet}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}